import { render } from "./Footbar.vue?vue&type=template&id=3ac5ef7e"
const script = {}

import "./Footbar.vue?vue&type=style&index=0&id=3ac5ef7e&lang=scss"
/* custom blocks */
import block0 from "./Footbar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__